import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Block } from '../../models/pages';

const allActionCreators = Object.assign({});

export class BlockComponent extends Component {

  getBlockModel() {
    return this.props.block || new Block();
  }

  getStepComponent() {
    const blockModel = this.getBlockModel();
    const DynamicBlock = blockModel.component;
    return DynamicBlock ? <DynamicBlock block={blockModel} /> : null;
  }

  render() {
    return <div className={'BlockComponent'}>
      <div className='blockLiner'>{this.getStepComponent()}</div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(BlockComponent));